module.exports = __webpack_public_path__ + "static/background-27d5be8d9bdbc4ffa59267fc67b451fc.png";